import React from 'react'
import { withSiteData } from 'react-static'
import styled from '@emotion/styled'

const Main = styled.main`
  margin-top: 70px;
  padding: 1rem;
  line-height: 1.5rem;

  @media (min-width: 64em) {
    margin: 0 auto;
    max-width: 960px;
    padding-top: 90px;
  }
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;
`

const Section = styled.section`
  position: relative;
  margin-bottom: 1rem;
`

const Form = styled.form`
  input,
  textarea {
    width: 100%;
    margin: 0.5rem 0;
    background: rgba(0, 0, 0, 0.05);
    display: block;
    padding: 0.8rem 0.4rem;
    color: inherit;
    font-family: inherit;
    // font-size: var(--inputFontSize);
    font-weight: inherit;
    line-height: 1.5rem;
    border: none;
    border-radius: 0.4rem;
    transition: box-shadow 0.5s;

    &:focus {
      outline: none;
      box-shadow: 0.1rem 0.1rem 0.1rem rgba(0, 0, 0, 0.1);
    }
  }

  button {
    margin: 1rem 0;
    padding: 1rem;
    width: 100%;
    color: #275236;
    border: none;
    background: none;
    border-radius: 0.4rem;
    box-shadow: 0.1rem 0.1rem 0.1rem rgba(0, 0, 0, 0.1);
  }
`

export default withSiteData(() => (
  <div>
    <Main>
      <Section>
        <Title>Ajánlatkérés</Title>
        <Form
          name="quotation"
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          action="/ajanlatkeres-sikeres/"
          subject="Ajánlatkérés"
        >
          <input type="hidden" name="form-name" value="quotation" />
          <input style={{ visibility: 'hidden' }} name="bot-field" />
          <input type="text" name="email" placeholder="email cím" required />
          <input type="phone" name="tel" placeholder="telefonszám" required />
          <textarea name="body" placeholder="leírás" required />
          <button type="submit">Elküld</button>
        </Form>
      </Section>
    </Main>
  </div>
))
